import { appInfo } from './AppInfo';
var ymstockAppInfo = {
    isPhone: function () {
        var loginType = parseInt(appInfo.getParam('loginType'), 10);
        //经典版
        var hasBindPhone = appInfo.getParam('hasBindPhone');
        var emoneyLoginType = appInfo.getParam('emoneyLoginType');
        if (emoneyLoginType === 7) {
            return false;
        }
        //低于8.8.3的版本没有emoneyLoginType等参数，仍按照loginType判断登录
        if (emoneyLoginType === '') {
            if (loginType === 2) {
                return true;
            }
        }
        else {
            if (hasBindPhone) {
                return true;
            }
            if (loginType === 2) {
                return true;
            }
        }
        return false;
    }
};
export default ymstockAppInfo;
//# sourceMappingURL=ymstockAppInfo.js.map